import { useState, useEffect, useCallback } from 'react';
import { useCheckoutApi } from '../../../../../../../../../../react-common/api/useCheckoutApi';
import { CheckoutSettings } from '@pdqdev/pdq-shared/dist/entities';

const useCheckoutSettings = () => {
  const [checkoutSettings, setCheckoutSettings] = useState<CheckoutSettings>();

  const failureHandler = useCallback(async () => {}, []);
  const checkoutApi = useCheckoutApi(failureHandler);
  const fetchData = async () => {
    const response = await checkoutApi.get(`/admin/v1/settings`);
    setCheckoutSettings(response.data as CheckoutSettings);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    checkoutSettings,
  };
};

export default useCheckoutSettings;
